import React from 'react';

interface UnreadIndicatorProps {
  children: React.ReactNode;
}

const UnreadIndicator: React.FC<UnreadIndicatorProps> = ({ children }) => (
  <div className="relative">
    <div className="absolute -left-4 top-1/2 -translate-y-1/2 size-2 bg-red-500 rounded-full" />
    {children}
  </div>
);

export default UnreadIndicator;
